/*
 * The sticky bars at the top and at the bottom of a page (a surface's header, the course
 * editor's save bar) cover what scrolls under them. While one is on the page, the root holds its
 * height (`--sticky-top`, `--sticky-bottom`): the page's scroll padding (styles/theme.css) keeps
 * whatever takes the focus clear of them (WCAG 2.4.11), and a sticky column can sit between them.
 */

/** A ref for a sticky bar: the root's `name` holds its height while it is on the page. */
function trackHeight(name: string) {
  return (element: HTMLElement | null) => {
    if (!element) return
    const root = document.documentElement
    const measure = () => root.style.setProperty(name, `${element.offsetHeight}px`)
    measure()
    // It grows when its content wraps (a narrower window, a longer message).
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure)
    observer?.observe(element)
    return () => {
      observer?.disconnect()
      root.style.removeProperty(name)
    }
  }
}

/** The ref of a surface's sticky header. */
export const stickyTop = trackHeight('--sticky-top')
/** The ref of a page's sticky bar at the bottom. */
export const stickyBottom = trackHeight('--sticky-bottom')
